import Button from "components/button";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { desktop, mobile } from "theme/breakpoints";

export const StyledNavigation = styled.div`
  position: relative;
  box-shadow: 0.059rem 0 1.175rem 0 rgba(0, 0, 0, 0.2);
`;

export const StyledMobile = styled.div`
  display: none;
  flex-direction: row;
  height: 2.35rem;

  ${mobile(css`
    display: flex;
  `)}
`;

export const StyledDesktop = styled.div`
  display: none;
  width: 18.35rem;

  flex-direction: column;

  ${desktop(css`
    display: flex;
  `)}
`;

export const StyledSection = styled.div`
  padding: 1.18rem;
`;

export const StyledSectionContents = styled.div`
  position: relative;
`;

export const StyledAddButton = styled(Button)`
  margin-top: 0.5rem;
  margin-left: 0.9375rem;
`;
